import React from 'react';

import { Container, Select, Label } from 'ui/components/styled';
import { getNumberOfPages, recalculatePage } from '../helpers';

const RowsPerPageComponent = ({
  rowsPerPage,
  rowsPerPageOptions = [10, 15, 20, 25, 30],
  onRowsPerPageChange,
  rowCount,
  currentPage,
  onPageChange,
  selectAllRowsItem = true,
  selectAllRowsItemText = 'All',
  paginationServer = true,
}) => {
  const options = rowsPerPageOptions.map((num) => ({
    label: num,
    value: num,
  }));

  if (selectAllRowsItem) {
    options.push({
      label: selectAllRowsItemText || rowCount,
      value: -1,
    });
  }

  const [perPage, setPerPage] = React.useState(rowsPerPage);

  const handleRowsPerPage = React.useCallback(
    ({ value }) => {
      const newRowsPerPage = Number(value);
      const updatedPage = getNumberOfPages(rowCount, newRowsPerPage);
      const recalculatedPage = recalculatePage(currentPage, updatedPage);
      onPageChange(recalculatedPage || 1);
      onRowsPerPageChange(newRowsPerPage, recalculatedPage);
      if (!paginationServer) setPerPage(newRowsPerPage);
    },
    [rowCount, currentPage, onRowsPerPageChange]
  );

  return (
    <Container flexDirection="row" alignItems="center" width="auto" height="auto">
      <Label variant="legend" fontSize="13px" mr="xs">
        Entries
      </Label>
      <Select
        testId="dt-entries"
        variant="minimal"
        caretColor="primary"
        minWidth="60px"
        minHeight="34px"
        options={options}
        value={paginationServer ? rowsPerPage : perPage}
        onChange={handleRowsPerPage}
      />
    </Container>
  );
};

export default RowsPerPageComponent;
